import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "@styles/components/movieCard.scss";
import useKeydown from "@hooks/useKeydown";
import { setCtrl } from "@app/global";
import { useDispatch } from "react-redux";
import { useImageFallback } from "@hooks/useImageFallback";

const MovieCard = React.memo(
  ({ style, isActive, name, poster, id, onCardClick }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const imageSrc = useImageFallback(poster);

    const handleNavigation = useCallback(() => {
      navigate(`/movie/${id}`);
      dispatch(setCtrl("movieInfo"));
    }, [navigate, id, dispatch]);

    useKeydown({
      isActive,
      ok: (index, row) => {
        if (onCardClick) {
          onCardClick(index, row);
        }
        handleNavigation();
      },
    });

    return (
      <div
        style={style}
        className={`movie-card_parent ${isActive ? "active" : ""}`}
        onClick={handleNavigation}
      >
        <div className="movie-card">
          <img src={imageSrc} alt={name} />
        </div>
        <p className={`title one-line`}>{name}</p>
      </div>
    );
  }
);

export default MovieCard;
